export const translateAdaptiveCardJson = (adaptiveCardJson, t) => {
	const translations = {
		Instruction: 'instruction-title',
		'Questions and Ratings': 'questions-and-ratings',
		'Overall Recommendations': 'overall-recommendations',
		'Do you recommend for this position?': 'Do you recommend for this position?',
		'Would you recommend for another position?': 'Would you recommend for another position?',
		'What are your overall thoughts on the candidate?':
			'What are your overall thoughts on the candidate?',
	};
	adaptiveCardJson.body.forEach((element) => {
		if (element.type === 'TextBlock' && translations[element.text]) {
			element.text = t(translations[element.text]);
		}

		if (element.type === 'Input.Recommendation' && translations[element.label]) {
			element.label = t(translations[element.label]);
		}

		if (element.type === 'Input.Text' && translations[element.label]) {
			element.label = t(translations[element.label]);
		}
	});

	return adaptiveCardJson;
};
